import cn from 'classnames'
import { ButtonHTMLAttributes, ReactNode } from 'react'

import cls from './styles.module.scss'

type TButtonVariants = 'primary'

type ButtonProps = {
    className?: string
    children: ReactNode
    isLoading?: boolean
    variant?: TButtonVariants
} & ButtonHTMLAttributes<HTMLButtonElement>

export const Button = ({
    className,
    children,
    isLoading,
    variant = 'primary',
    disabled,
    ...props
}: ButtonProps) => (
    <button
        className={cn(cls.root, className)}
        type="button"
        disabled={isLoading || disabled}
        data-variant={variant}
        {...props}
    >
        {children}
    </button>
)
